// Ruta: /src/utils/domain.ts
// ═══════════════════════════════════════════════════════════════
// Dominio base de LORA. Única fuente de verdad para construir los
// hosts de tenants (empresa.lorachat.net) y del sistema (admin.lorachat.net).
//
//   Producción → VITE_BASE_DOMAIN sin definir   → 'lorachat.net'
//   Staging    → VITE_BASE_DOMAIN=staging.lorachat.net (lo inyecta el
//                workflow deploy-staging.yml) → admin.staging.lorachat.net,
//                empresa.staging.lorachat.net
// ═══════════════════════════════════════════════════════════════
const fromEnv = (import.meta.env.VITE_BASE_DOMAIN as string | undefined)?.trim().toLowerCase()

export const BASE_DOMAIN: string = fromEnv || 'lorachat.net'
export const ADMIN_HOST: string = `admin.${BASE_DOMAIN}`
export const ADMIN_URL: string = `https://${ADMIN_HOST}`
